<template>
  <section class="core">
    <div class="container">
      <a-typography-title :level="1">
        社区核心贡献者
      </a-typography-title>
      <a-typography-paragraph>
        感谢有你，在星汉未来开源项目中，做出突出贡献。(3个PR解锁证书)
      </a-typography-paragraph>
      <a-row :gutter="[40,20]">
        <a-col v-for="item in expand.list"
               :xs="24" :lg="12">
          <a class="box_info" target="_blank"
             :href="item.href">
            <i class="icon"
               :class="`i_${item.icon}`" />
            <div class="info">
              <p>{{ item.name }}</p>
              <p>{{ item.path }}</p>
              <p>
                <span>证书编号：</span>
                {{ item.num }}
              </p>
              <p>
                <span>证书发放时间：</span>
                {{ item.time }}
              </p>
              <p>
                <span>参与项目：</span>
                {{ item.project.join('、') }}
              </p>
            </div>
          </a>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'community_core',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            icon: 1,
            name: 'baiyutang',
            href: 'https://github.com/baiyutang',
            path: '广州',
            num: 'GX2022092801',
            time: '2022年12月',
            project: [
              'BridgX',
              'CostPilot'
            ]
          },
          {
            icon: 2,
            name: 'zhuyaguang',
            href: 'https://github.com/zhuyaguang',
            path: '杭州',
            num: 'GX2022092802',
            time: '2022年12月',
            project: [
              'BridgX'
            ]
          },
          {
            icon: 3,
            name: 'sdaulibin',
            href: 'https://github.com/sdaulibin',
            path: '青岛',
            num: 'GX2022092803',
            time: '2022年12月',
            project: [
              'BridgX',
              'CostPilot'
            ]
          },
          {
            icon: 4,
            name: 'lshmouse',
            href: 'https://github.com/lshmouse',
            path: '北京',
            num: '-',
            time: '-',
            project: [
              'CostPilot'
            ]
          },
          {
            icon: 5,
            name: 'fengshunli',
            href: 'https://github.com/fengshunli',
            path: '北京',
            num: '-',
            time: '-',
            project: [
              'CostPilot'
            ]
          },
          {
            icon: 6,
            name: 'wy-hua',
            href: 'https://github.com/wy-hua',
            path: '武汉',
            num: '-',
            time: '-',
            project: [
              'BridgX',
              'CostPilot'
            ]
          },
          {
            icon: 7,
            name: 'zvanYang',
            href: 'https://github.com/ZvanYang',
            path: '北京',
            num: '-',
            time: '-',
            project: [
              'CostPilot'
            ]
          },
          {
            icon: 8,
            name: 'os7blue',
            href: 'https://github.com/os7blue',
            path: '乌鲁木齐',
            num: '-',
            time: '-',
            project: [
              'CostPilot'
            ]
          },
          {
            icon: 9,
            name: 'michael-zzz',
            href: 'https://github.com/michael-zzz',
            path: '杭州',
            num: '-',
            time: '-',
            project: [
              'CostPilot'
            ]
          },
          {
            icon: 10,
            name: 'LL-res',
            href: 'https://github.com/LL-res',
            path: '北京',
            num: '-',
            time: '-',
            project: [
              'BridgX',
              'CostPilot'
            ]
          }
        ]
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';

.core {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space_mo 0 @space;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.ant-row {
  position: relative;
  margin: @margin_mo 0 0;
}

.box_info {
  @style: transform @time, box-shadow @time;
  overflow: hidden;
  display: block;
  position: relative;
  max-width: 560px;
  padding: 20px 20px 20px 30px;
  margin: 0 auto;
  border-radius: 5px;
  .shadow(0 0 10px fade(@color_black, 5));
  .transition(@style);
  
  &:hover {
    .shadow(0 0 20px fade(@color_black, 10));
    .transform(scale(1.01));
    
    .icon {
      &::before {
        .transform(translate(-5px, -5px));
      }
      
      &::after {
        .transform(translate(5px, 5px));
      }
    }
  }
  
  .icon {
    @wh: 110px;
    float: left;
    display: block;
    position: relative;
    width: @wh;
    height: @wh;
    margin: 0 30px 0 0;
    .bg('@{image}core_photo.png', @wh*10, @wh);
    
    .loop(@i) when (@i<=10) {
      &.i_@{i} {
        background-position: -@wh*(-1+@i) 0;
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      .bg('@{image}core_decorate.png', 91px, 65px);
      .transition(transform @time);
    }
    
    &::before {
      top: -6px;
      left: 2px;
      width: 53px;
      height: 65px;
      background-position: 0 0;
    }
    
    &::after {
      right: 10px;
      bottom: -6px;
      width: 36px;
      height: 25px;
      background-position: -55px 0;
    }
  }
  
  .info {
    float: left;
    max-width: calc(~'100% - 120px');
    
    p {
      margin: 5px 0 0;
      .font(left, @text, @color_12, @text);
      
      &:nth-child(1) {
        margin: 0;
        color: @color_6;
        font-weight: bold;
      }
      
      &:nth-child(2),
      &:nth-child(3) {
        margin: 10px 0 0;
      }
      
      span {
        color: @color_13;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .core {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
  }
  
  .box_info {
    padding: 20px 0 20px 5px;
    
    .icon {
      margin: 0 10px 0 0;
    }
  }
}
</style>